import Keycloak from "keycloak-js";

//const keycloak = new Keycloak({
//  url: "http://localhost:8080",      // Keycloak base URL
//  realm: "mako-realm",          // match your imported realm
//  clientId: "mako-react-app",        // matches your JSON
//});

const keycloak = new Keycloak({
  url: "https://auth.makodesk.com",      // Keycloak base URL
  realm: "mako-realm",          // match your imported realm
  clientId: "mako-react-app",        // matches your JSON
});

export default keycloak;
